export default "__VITE_ASSET__BWeNf1_k__"